// lazy load images
const lazyImages = document.querySelectorAll("[data-src]");

// about-me images extra class
// const aboutMeImageGrid = document.querySelector(".about-me-images-grid");

const preloadImage = (img) => {
  const src = img.getAttribute("data-src");
  //   console.log(src);

  if (!src) {
    return;
  }
  img.src = src;
};

const lazyImgObserver = new IntersectionObserver((entries, lazyImgObserver) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) {
      return;
    } else {
      preloadImage(entry.target);
      // entry.target.classList.remove("lazy");
      lazyImgObserver.unobserve(entry.target);
    }
  });
});

lazyImages.forEach((image) => {
  lazyImgObserver.observe(image);
});

// lazyImgObserver.observe(aboutMeImageGrid);

// console.log(lazyImages);

// gsap animation

// hero section animation

var tl = gsap.timeline();

tl.from(".hero-section h1", {
  y: 0,
  opacity: 0,
  duration: 0.5,
  delay: 0.2,
  ease: "power2.inOut",
});

tl.from(
  ".hero-section .p-caption",
  {
    y: -50,
    opacity: 0,
    duration: 1,
    delay: 0,
    ease: "power2.inOut",
  },
  "-=0.5"
);

tl.from(
  ".hero-section .p-lg, .heroCTA-wrapper",
  {
    y: 50,
    opacity: 0,
    duration: 1,
    delay: 0,
    stagger: 0.1,
    ease: "power2.inOut",
  },
  "-=0.5"
);

gsap.from(".ourProcessDetail-wrapper", {
  y: 80,
  opacity: 0,
  duration: 0.5,
  delay: 0,
  stagger: 0.2,
  scrollTrigger: {
    trigger: ".ourProcessDetail-wrapper",
    scroller: "body",
    markers: false,
    start: "top 80%",
  },
});

gsap.from(".missionVision-wrapper h2, .missionVision-wrapper p, .btn-wrapper", {
  y: 50,
  opacity: 0,
  duration: 0.4,
  delay: 0,
  stagger: 0.2,
  scrollTrigger: {
    trigger: ".missionVision-wrapper",
    scroller: "body",
    markers: false,
    start: "top 80%",
  },
});

gsap.from(".ceo-wrapper h2, .ceoImage-wrapper", {
  y: 50,
  opacity: 0,
  duration: 0.4,
  delay: 0,
  stagger: 0.2,
  scrollTrigger: {
    trigger: ".ceo-wrapper",
    scroller: "body",
    markers: false,
    start: "top 80%",
  },
});

gsap.from(".whyKainest-wrapper h2, .whyKainestItem-wrapper", {
  y: 50,
  opacity: 0,
  duration: 0.4,
  delay: 0,
  stagger: 0.2,
  scrollTrigger: {
    trigger: ".whyKainest-wrapper",
    scroller: "body",
    markers: false,
    start: "top 80%",
  },
});

gsap.from(".contactUs-wrapper h2, .contactUs-wrapper p", {
  y: 50,
  opacity: 0,
  duration: 0.4,
  delay: 0,
  stagger: 0.2,
  scrollTrigger: {
    trigger: ".contactUs-section",
    scroller: "body",
    markers: false,
    start: "top 80%",
  },
});

// our process section animation

gsap.registerPlugin(ScrollTrigger);

const splitTypes = document.querySelectorAll(".reveal-type");

splitTypes.forEach((char, i) => {
  const text = new SplitType(char, { types: "words" });

  gsap.from(text.words, {
    scrollTrigger: {
      trigger: char,
      start: "top 80%",
      end: "top 20%",
      scrub: true,
    },
    opacity: 0.2,
    stagger: 0.1,
  });
});

// ourProcessDetail js
let question = document.getElementsByClassName("ourProcessItemHeading-wrapper");
for (let i = 0; i < question.length; i++) {
  question[i].addEventListener("click", toggleItem, false);
}

function toggleItem() {
  this.parentNode.classList.toggle("active");

  gsap.from(
    ".ourProcessItemContent-wrapper h2, .ourProcessItemContent-wrapper p",
    {
      y: 50,
      opacity: 0,
      duration: 0.5,
      delay: 0,
    }
  );

  gsap.from(".ourProcessItemImage img", {
    y: 50,
    opacity: 1,
    duration: 0.5,
    delay: 0,
  });

  let allAccItems = document.getElementsByClassName("ourProcessItem-wrapper");
  for (let i = 0; i < allAccItems.length; i++) {
    if (allAccItems[i] !== this.parentNode) {
      allAccItems[i].classList.remove("active");
    }
  }
}

//  suresh code 
document.getElementById("currentYear").textContent = new Date().getFullYear();

// document.querySelectorAll(".header-links").forEach(link => {
//   if (link.href === window.location.href) {
//     link.classList.add("active");
//   }
// });

// Hamburger Menu Toggle
document.getElementById("hamburger").addEventListener("click", function () {
  document.getElementById("navMenu").classList.toggle("show");
});

// dropdown
document.querySelector(".dropdown-btn").addEventListener("click", function () {
  document.querySelector(".dropdown").classList.toggle("show");
  document.querySelector(".dropdown-btn").classList.toggle("active");
});

// Close dropdown when clicking outside
window.addEventListener("click", function (e) {
  if (!document.querySelector(".dropdown").contains(e.target)) {
    document.querySelector(".dropdown").classList.remove("show");
    document.querySelector(".dropdown-btn").classList.remove("active");
  }
});


// animation
gsap.from(".aboutus-section, .missionItem-wrapper", {
  y: 50,
  opacity: 0,
  duration: 0.4,
  delay: 0,
  stagger: 0.2,
  scrollTrigger: {
    trigger: ".aboutus-section",
    scroller: "body",
    markers: false,
    start: "top 80%",
  },
});